import { getYouTubeEmbedUrl, getYouTubeThumbnailUrl, getYouTubeVideoId } from "@/utils/youtube"

export { handleYouTubeThumbnailFallback } from "@/utils/youtube"

export type VideoProvider = "youtube" | "facebook" | "unknown"

export function getVideoProvider(url: string | null | undefined): VideoProvider {
  if (!url) return "unknown"
  if (getYouTubeVideoId(url)) return "youtube"
  if (/facebook\.com|fb\.watch/i.test(url)) return "facebook"
  return "unknown"
}

export function getVideoEmbedUrl(
  url: string | null | undefined,
  { autoplay = true }: { autoplay?: boolean } = {}
): string | null {
  if (!url) return null

  const youtubeEmbed = getYouTubeEmbedUrl(url, { autoplay })
  if (youtubeEmbed) return youtubeEmbed

  if (getVideoProvider(url) === "facebook") {
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&width=1280&autoplay=${autoplay ? 1 : 0}`
  }

  return null
}

export function getVideoThumbnailUrl(url: string | null | undefined): string | null {
  return getYouTubeThumbnailUrl(url)
}
